import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../config/firebase";

function ChaptersTab() {
  const [chapters, setChapters] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // NOUVEAUX ÉTATS NOTIFICATIONS
  const [toast, setToast] = useState(null);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  const [formData, setFormData] = useState({
    city: "",
    lead: "",
    role: "City Lead",
    linkedin: "",
    linkedin2: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [currentImageUrl, setCurrentImageUrl] = useState("");

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "chapters"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      data.sort((a, b) => a.city.localeCompare(b.city));
      setChapters(data);
    });
    return () => unsub();
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleImageUpload = async (file) => {
    if (!file) return null;
    const storageRef = ref(storage, `chapters/${Date.now()}_${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);

    try {
      let finalImageUrl = currentImageUrl;

      if (imageFile) {
        finalImageUrl = await handleImageUpload(imageFile);
      }

      if (!finalImageUrl) {
        showToast("Veuillez ajouter une image pour la ville !", "error");
        setIsUploading(false);
        return;
      }

      const chapterPayload = { ...formData, image: finalImageUrl };

      if (editingId) {
        await updateDoc(doc(db, "chapters", editingId), chapterPayload);
        showToast("Chapter modifié avec succès !");
      } else {
        await addDoc(collection(db, "chapters"), chapterPayload);
        showToast("Chapter créé avec succès !");
      }

      closeModal();
    } catch (err) {
      showToast("Erreur : " + err.message, "error");
    }
    setIsUploading(false);
  };

  const confirmDelete = async () => {
    if (!deleteTargetId) return;
    try {
      await deleteDoc(doc(db, "chapters", deleteTargetId));
      showToast("Chapter supprimé !");
    } catch (err) {
      showToast("Erreur lors de la suppression.", "error");
    }
    setDeleteTargetId(null);
  };

  const openEditModal = (chapter) => {
    setEditingId(chapter.id);
    setFormData({
      city: chapter.city || "",
      lead: chapter.lead || "",
      role: chapter.role || "City Lead",
      linkedin: chapter.linkedin || "",
      linkedin2: chapter.linkedin2 || "",
    });
    setCurrentImageUrl(chapter.image || "");
    setImageFile(null);
  };

  const closeModal = () => {
    setEditingId(null);
    setFormData({
      city: "",
      lead: "",
      role: "City Lead",
      linkedin: "",
      linkedin2: "",
    });
    setCurrentImageUrl("");
    setImageFile(null);
  };

  return (
    <div className="fade-in">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h3>Liste des Chapters ({chapters.length})</h3>
        <button
          onClick={() => openEditModal({})}
          style={{ ...btnStyle, background: "#ffbd00" }}
        >
          + NOUVEAU CHAPTER
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {chapters.map((chap) => (
          <div
            key={chap.id}
            style={{
              background: "rgba(255,255,255,0.03)",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.05)",
              overflow: "hidden",
            }}
          >
            <img
              src={chap.image}
              alt=""
              style={{ width: "100%", height: "150px", objectFit: "cover" }}
            />
            <div style={{ padding: "20px" }}>
              <strong
                style={{
                  fontSize: "1.2rem",
                  color: "#fff",
                  display: "block",
                  marginBottom: "5px",
                }}
              >
                {chap.city}
              </strong>
              <p style={{ fontSize: "0.9rem", color: "#888", margin: 0 }}>
                {chap.lead}
              </p>

              <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <button
                  onClick={() => openEditModal(chap)}
                  style={{
                    flex: 1,
                    padding: "8px",
                    background: "rgba(255,255,255,0.1)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Modifier
                </button>
                <button
                  onClick={() => setDeleteTargetId(chap.id)}
                  style={{
                    padding: "8px 15px",
                    background: "transparent",
                    border: "1px solid #ff3366",
                    color: "#ff3366",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MODALE CRÉATION / ÉDITION */}
      {editingId !== null && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2>{editingId ? "Modifier le Chapter" : "Créer un Chapter"}</h2>
              <button
                onClick={closeModal}
                style={{
                  background: "transparent",
                  color: "white",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            <form
              onSubmit={handleSubmit}
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              <input
                type="text"
                placeholder="Ville (ex: PARIS)"
                required
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
                style={inputStyle}
              />
              <input
                type="text"
                placeholder="Nom complet du/des City Lead(s)"
                required
                value={formData.lead}
                onChange={(e) =>
                  setFormData({ ...formData, lead: e.target.value })
                }
                style={inputStyle}
              />
              <input
                type="url"
                placeholder="Lien LinkedIn principal"
                required
                value={formData.linkedin}
                onChange={(e) =>
                  setFormData({ ...formData, linkedin: e.target.value })
                }
                style={inputStyle}
              />
              <input
                type="url"
                placeholder="Lien LinkedIn 2 (Optionnel)"
                value={formData.linkedin2}
                onChange={(e) =>
                  setFormData({ ...formData, linkedin2: e.target.value })
                }
                style={inputStyle}
              />

              <div
                style={{
                  background: "rgba(255,255,255,0.05)",
                  padding: "15px",
                  borderRadius: "8px",
                  border: "1px dashed #555",
                }}
              >
                <p style={{ margin: "0 0 10px 0", fontSize: "0.9rem" }}>
                  Image de la ville
                </p>
                {currentImageUrl && !imageFile && (
                  <img
                    src={currentImageUrl}
                    alt="Actuelle"
                    style={{
                      height: "60px",
                      borderRadius: "4px",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  />
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files[0])}
                  style={{ color: "white" }}
                />
              </div>

              <button
                type="submit"
                disabled={isUploading}
                style={{
                  ...btnStyle,
                  background: "#ffbd00",
                  opacity: isUploading ? 0.5 : 1,
                }}
              >
                {isUploading
                  ? "Enregistrement en cours..."
                  : editingId
                    ? "METTRE À JOUR"
                    : "PUBLIER"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* --- AFFICHAGE DU TOAST --- */}
      {toast && <div className={`cms-toast ${toast.type}`}>{toast.msg}</div>}

      {/* --- MODALE DE CONFIRMATION DE SUPPRESSION --- */}
      {deleteTargetId && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <h3>Action irréversible</h3>
            <p>
              Es-tu sûr de vouloir supprimer ce chapter ? Il disparaîtra
              immédiatement de la carte du site.
            </p>
            <div className="confirm-actions">
              <button
                className="confirm-btn-cancel"
                onClick={() => setDeleteTargetId(null)}
              >
                Annuler
              </button>
              <button className="confirm-btn-delete" onClick={confirmDelete}>
                Oui, supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// --- STYLES ---
const inputStyle = {
  padding: "12px",
  background: "rgba(0,0,0,0.5)",
  border: "1px solid #333",
  color: "white",
  borderRadius: "8px",
  width: "100%",
  boxSizing: "border-box",
};
const btnStyle = {
  padding: "12px 20px",
  color: "#000",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
};
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.8)",
  backdropFilter: "blur(5px)",
  zIndex: 1000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const modalContentStyle = {
  background: "#111118",
  padding: "30px",
  borderRadius: "15px",
  border: "1px solid #333",
  width: "90%",
  maxWidth: "500px",
  maxHeight: "90vh",
  overflowY: "auto",
};

export default ChaptersTab;
